<!-- Accent -->
<div class="flex flex-col gap-4">
    <!-- Large -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle large accent">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <!-- Medium -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle accent">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <!-- Small -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle small accent">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>

<!-- Primary -->
<div class="flex flex-col gap-4 mt-8">
    <!-- Large -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle large primary">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <!-- Medium -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle primary medium">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <!-- Small -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle small primary">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>

<!-- Neutral -->
<div class="flex flex-col gap-4 mt-8">
    <!-- Large -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle large neutral">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <!-- Medium -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle neutral medium">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <!-- Small -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle small neutral">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>

<!-- Warn -->
<div class="flex flex-col gap-4 mt-8">
    <!-- Large -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle large warn">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <!-- Medium -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle warn medium">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <!-- Small -->
    <div>
        <mat-button-toggle-group class="v2-button-toggle small warn">
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
            <mat-button-toggle>button</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>
